import { render } from "./DepositPage.vue?vue&type=template&id=1fdebc50&scoped=true"
import script from "./DepositPage.vue?vue&type=script&lang=js"
export * from "./DepositPage.vue?vue&type=script&lang=js"

import "./DepositPage.vue?vue&type=style&index=0&id=1fdebc50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdebc50"]])

export default __exports__